"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _close = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close"));

var _button = _interopRequireDefault(require("@amzn/meridian-tokens/component/button"));

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _button2 = _interopRequireDefault(require("../button"));

var _icon = _interopRequireDefault(require("../icon"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _useFocus2 = _interopRequireDefault(require("../_use-focus"));

var _buttonStyles = require("../button/button-styles");

var _borderRadius = _interopRequireDefault(require("./../_utils/border-radius"));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var hidden = _ref.hidden,
      borderRadiusRight = _ref.borderRadiusRight,
      focus = _ref.focus;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    height: "100%",
    visibility: hidden ? "hidden" : undefined,
    // Bring the clear button up over the search button when focused so that its
    // focus ring isn't clipped
    "&:focus": {
      zIndex: _elevation.elevationForeground
    },
    // Set the button border radius
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"])
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"])
  }), // Set the focus ring border radius
  (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"]),
    outlineOffset: 1
  }), (0, _defineProperty2["default"])({}, "[dir=\"rtl\"] &", (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"]),
    outlineOffset: 1
  })));
}, ["hidden", "borderRadiusRight", "focus"]);

var InputClearButton = function InputClearButton(props) {
  var hidden = props.hidden,
      borderRadiusRight = props.borderRadiusRight;
  var t = (0, _theme.useTheme)(_button["default"], "button");

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_button2["default"], (0, _extends2["default"])({
    type: "icon",
    onClick: props.onClick,
    disabled: props.disabled,
    className: styles(t, {
      hidden: hidden,
      borderRadiusRight: borderRadiusRight,
      focus: focus && focusTrigger === "keyboard"
    }),
    "aria-hidden": hidden,
    label: props.label
  }, focusProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }));
};

InputClearButton.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadiusRight: _propTypes["default"].number,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onClick: _propTypes["default"].func
} : {};
InputClearButton.defaultProps = {
  label: "Clear input"
};
var _default = InputClearButton;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_input-clear-button/input-clear-button.js
// module id = 864
// module chunks = 0